// Captures Google Ads identifiers (gclid, gbraid, wbraid) from the URL
// and stores them in first-party cookies for up to 90 days.
import { setCookieAdvanced } from "./cookies";
import { getGBRAID, getGCLID, getWBRAID, getClientId } from "./google-cookies";
import { getEnvironmentType, EnvironmentType } from "./environment";

const IDENTIFIER_PARAM_NAMES: ReadonlyArray<string> = [
  "gclid",
  "gbraid",
  "wbraid",
];
const COOKIE_TTL_DAYS = 90;

function captureAndPersistAdParams(): void {
  try {
    if (typeof window === "undefined" || typeof document === "undefined")
      return;

    const searchParams = new URLSearchParams(window.location.search);

    IDENTIFIER_PARAM_NAMES.forEach((paramName) => {
      const paramValue = searchParams.get(paramName);
      if (paramValue && paramValue !== "undefined" && paramValue !== "null") {
        // Store using a prefixed cookie name to avoid collisions
        const cookieName = `_${paramName}`;
        setCookieAdvanced(cookieName, paramValue, {
          days: COOKIE_TTL_DAYS,
          sameSite: "Lax",
        });
      }
    });
  } catch {
    // Intentionally noop
  }
}

// Run immediately on module import so it's executed as early as possible
captureAndPersistAdParams();

if (getEnvironmentType() !== EnvironmentType.PRODUCTION) {
  window.addEventListener("DOMContentLoaded", () => {
    new Promise(async (resolve) => {
      const gClientId = await getClientId();
      const gclid = getGCLID();
      const gbraid = getGBRAID();
      const wbraid = getWBRAID();

      resolve(true);
    });
  });
}

export { captureAndPersistAdParams };
